import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>@taerim.dev</p>
    </footer>
  );
};

export default Footer;